export enum PurchaseOrderInvoiceLabel {
  REMOVED_FROM_FISCAL_PANEL = 'REMOVED_FROM_FISCAL_PANEL',
  SENT_WITHOUT_INVOICE = 'SENT_WITHOUT_INVOICE',
  MANUALLY_ASSOCIATED = 'MANUALLY_ASSOCIATED',
  AUTOMATICALLY_ASSOCIATED = 'AUTOMATICALLY_ASSOCIATED',
  PRIOR_TO_DEMAND = 'PRIOR_TO_DEMAND',
  NOT_ASSOCIATED = 'NOT_ASSOCIATED',
}
